import { connectRouter, RouterState } from "connected-react-router";
import { History } from "history";
import { combineReducers, Reducer } from "redux";
import AreasReducer from "./Areas/AreaReducer";
import { AreaState, IAreaState } from "./Areas/AreaState";
import AuditTemplateReducer from "./AuditTemplates/AuditTemplateReducer";
import { AuditTemplateState, IAuditTemplateState } from "./AuditTemplates/AuditTemplateState";
import { AuthenticationState, IAuthenticationState } from "./Authentication/AuthenticationActionTypes";
import AuthenticationReducer from "./Authentication/AuthenticationReducer";
import ChecklistTemplateReducer from "./ChecklistTemplates/ChecklistTemplateReducer";
import { ChecklistTemplateState, IChecklistTemplateState } from "./ChecklistTemplates/ChecklistTemplateState";
import { ILoadingState, LoadingState } from "./Loading/LoadingActionTypes";
import LoadingReducer from "./Loading/LoadingReducer";
import { IMessageToasterState, MessageToasterState } from "./MessageToaster/MessageToasterActionTypes";
import MessageReducer from "./MessageToaster/MessageToasterReducer";
import ShiftReducer from "./Shifts/ShiftReducer";
import { IShiftState, ShiftState } from "./Shifts/ShiftState";
import TaskReducer from "./Tasks/TaskReducer";
import { ITaskState, TaskState } from "./Tasks/TaskState";
import TaskTemplateReducer from "./TaskTemplates/TaskTemplateReducer";
import { ITaskTemplateState, TaskTemplateState } from "./TaskTemplates/TaskTemplateState";

export interface IApplicationState {
    authenticationState: IAuthenticationState;
    router: RouterState;
    loadingState: ILoadingState;
    messageToasterState: IMessageToasterState;
    taskState: ITaskState;
    taskTemplateState: ITaskTemplateState;
    auditTemplateState: IAuditTemplateState;
    checklistTemplateState: IChecklistTemplateState;
    areaState: IAreaState;
    shiftState: IShiftState;
}

export class ApplicationState implements IApplicationState {
    public authenticationState: IAuthenticationState = new AuthenticationState();
    public router: RouterState;
    public loadingState: ILoadingState = new LoadingState();
    public messageToasterState: IMessageToasterState = new MessageToasterState();
    public taskState: ITaskState = new TaskState();
    public taskTemplateState: ITaskTemplateState = new TaskTemplateState();
    public auditTemplateState: IAuditTemplateState = new AuditTemplateState();
    public checklistTemplateState: IChecklistTemplateState = new ChecklistTemplateState();
    public areaState: IAreaState = new AreaState();
    public shiftState: IShiftState = new ShiftState();
}

export const storeReducer = (history: History): Reducer<IApplicationState> => combineReducers<IApplicationState>({
    router: connectRouter(history),
    authenticationState: AuthenticationReducer,
    loadingState: LoadingReducer,
    messageToasterState: MessageReducer,
    taskState: TaskReducer,
    taskTemplateState: TaskTemplateReducer,
    auditTemplateState: AuditTemplateReducer,
    checklistTemplateState: ChecklistTemplateReducer,
    areaState: AreasReducer,
    shiftState: ShiftReducer
});

export const whitelistStorage: string[] = [
    "authenticationState"
];


// WEBPACK FOOTER //
// ./src/Store/Store.tsx